import packageJson from '../../package.json';

export const environment = {
  production: false,
  apiUri: 'https://register-dev.plusmore.co.za/api',
  version: `dev-${packageJson.version}`,
  recaptchaKey: '6LcnO_krAAAAALIQLcXeumek8n2C-rUzAoYVkSPi',
};
